import { Features } from '@shared/DTO/features';
import { EventBusMessage } from '../models/event-bus-message.model';

const EventKinds = {
  update: 'Update features',
};

const update: (features: Features) => EventBusMessage<Features> = (features) => ({
  kind: EventKinds.update,
  payload: features,
});

const Events = {
  updateFeatures: update,
};

export { Events as FeaturesEvents };
export { EventKinds as FeaturesEventKinds };
